module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"NYC Vintage Map","short_name":"NYC Vintage Map","start_url":"/","background_color":"#FF3C5C","theme_color":"#FF3C5C","display":"minimal-ui","icon":"src/images/logo-nyc.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"74cd994694c40eadc789a7163518d948"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
